import React, { useState } from "react";
import {
    Grid,
    RadioGroup,
    useMediaQuery,
    FormControlLabel,
    Radio,
    Dialog,
    DialogContentText,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    FormHelperText,
} from "@mui/material";
import { useFormikContext } from "formik";
import { useTheme } from "@mui/material/styles";

const RadioButtonsSuicidalThoughts = ({ id, name, options, className, question, triggerAnswers, ...otherProps }) => {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [value, setValue] = useState("yes");

    const fullScreen = useMediaQuery(theme.breakpoints.down("xl"));

    const formik = useFormikContext();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (event) => {
        if (triggerAnswers.includes(event.target.value)) {
            handleClickOpen();
        }

        formik.setFieldValue(name, event.target.value);
        setValue(event.target.value);
    };

    return (
        <Grid container className={className}>
            <Grid item xs={12}>
                {question != null && (
                    <Typography variant="h6" htmlFor={id} tabindex="0">
                        {question}
                    </Typography>
                )}
            </Grid>
            <RadioGroup name="RadioButton" value={value} onChange={handleChange}>
                {options.map((choice) => (
                    <FormControlLabel
                        value={choice["value"]}
                        control={<Radio aria-label={"radio button"} tabindex="0" />}
                        label={
                            <span
                                style={{
                                    color: formik.errors[name] ? "#f44336" : null,
                                }}
                            >
                                {choice["radioLabel"]}
                            </span>
                        }
                        tabIndex="0"
                    />
                ))}
            </RadioGroup>

            {formik.errors[name] ? (
                <FormHelperText error={true} style={{ color: "#f44336" }}>
                    {formik.errors[name] ? formik.errors[name].errors : null}
                </FormHelperText>
            ) : null}

            <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
                <DialogContent>
                    <DialogContentText style={{ color: "black" }}>
                        <Typography>
                            In this questionnaire you answer that you have frequent thoughts of self-harm or suicide. If
                            you have difficult thoughts like this it is important to recognise them and work with the
                            right people to deal with them.
                        </Typography>
                        <br />
                        <br />

                        <Typography>
                            If you are at risk of acting on these thoughts right now please call 999 or go to A&E. If
                            you need help urgently for your mental health, but it's not an emergency,{" "}
                            <a href="https://111.nhs.uk/" target="_blank">
                                get help from NHS 111 online
                            </a>{" "}
                            or call 111
                        </Typography>
                        <br />
                        <br />

                        <Typography>
                            Mental health emergencies are a health emergency like any other. If you have support from
                            mental health services you could also give them a call if you're feeling particularly at
                            risk. Talking to your GP or a trusted person in your life is also a good step.
                        </Typography>
                        <br />
                        <br />

                        <Typography>
                            Below are several other forms of support:
                            <ul>
                                <li>
                                    Samaritans- call 116 123 (available 24/7) or email jo@samaritans.org (for a reply
                                    within 24 hrs).{" "}
                                    <a href="https://www.samaritans.org/" target="_blank">
                                        www.samaritans.org
                                    </a>
                                </li>

                                <li>
                                    Text SHOUT to 85258 if you don't want to talk.{" "}
                                    <a href="https://www.giveusashout.org/" target="_blank">
                                        www.giveusashout.org
                                    </a>
                                </li>

                                <li>
                                    Campaign Against Living Miserably - call 0800 585858. Lines open 5 PM to midnight.{" "}
                                    <a href="https://www.thecalmzone.net" target="_blank">
                                        www.thecalmzone.net
                                    </a>
                                </li>
                            </ul>
                        </Typography>
                        <br />
                        <br />

                        <Typography>
                            It's okay to talk about suicide. Things can get better, no matter how bleak they can seem.
                        </Typography>
                        <br />
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ padding: "0px 40px 20px 0px" }}>
                    <Button onClick={handleClose} sx={{ fontSize: "1.2rem" }} color="primary" autoFocus>
                        Okay
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
};

export default RadioButtonsSuicidalThoughts;
